import React, { useState, useEffect, Fragment } from 'react';
import MultiSelectVertical from '../../../MultiSelectVertical/MultiSelectVertical';
import SingleSelect from '../../../SingleSelect/SingleSelect';
import SingleSelectHorizontal from './../ClickBitInteraction/ClickBitInteraction';
import SingleSelectVertical from '../../../SingleSelectVertical/SingleSelectVertical';
import './Tabs.scss';
import Button from '../../../../partials/Button/Button'
import axios from "axios";
import Instructions from '../../../../partials/Instructions/Instructions'

const Tabs = (props) => {

  const { data, children, currentTab, nextTab, changeTab, prevPage, nextPage, changePage, page, changeActionVisibility, retryQuiz, onComplete, onSetTitle, onSetInstructions } = props;

  const [currentStep, setCurrentStep] = useState(0);
  const [score, setScore] = useState();
  const [currentSubTab, setCurrentSubTab] = useState(0);
  console.log(onComplete, "123123123")
  console.log(props, "1123123123")

  const onDownload = (url, fileName) => {
    download(url, fileName)

  }

  const nextStep = (err) => {
    let errors = 0;
    let steps = data.tabs[currentTab].tabs.steps;
    if (err) {
      steps[currentStep].completed = false;
    } else {
      steps[currentStep].completed = true;
    }


    // filter for imcomplete steps
    steps.forEach((step) => {
      if (!step.completed) {
        errors += 1;
      }
    });

    console.log(data, "data123123");

    const stepsLength = data.tabs[currentTab].tabs.steps.length;
    if (currentStep + 1 < stepsLength) {
      setCurrentStep(currentStep + 1);
    } else {
      onComplete();
    }
  }

  const changeSubTab = (tabIndex) => {
    setCurrentSubTab(tabIndex);
  }

  useEffect(() => {
    props.onSetTitle(data.tabs[currentTab].tabs.title);
    props.onSetInstructions(data.tabs[currentTab].tabs.subinterTitle);
  }, [currentTab])



  return (
    <div className="tabs">
      <div className="tab-bar tab_none">
        {data.tabs.map((tab, tabIndex) => (
          <div className={`global_button_two tab-item ${tabIndex === currentTab ? 'active' : ''}`} key={`tab-item-${tabIndex}`} onClick={() => { changeTab(tabIndex); }}>
            {tab.locked &&
              <i className="mr-1 fa fa-lock"></i>
            }
          </div>

        ))}
      </div>
      {data.tabs.map((tab, tabIndex) => (
        <>
          <Fragment key={`tab-fragment-${tabIndex}`}>

            {tab.type === 'instructions' ?

              <div className={`tab-content ${tabIndex === currentTab ? 'active' : ''}`} key={`tab-content-${tabIndex}`}>
                {tab.sections.map((section, sectionIndex) => {
                  return (
                    <div className={`section ${page === sectionIndex ? 'active' : ''}`} key={`section-${sectionIndex}`}>
                      <div className="flex2 bg_bdr">
                        <h2 className="section-title section_titleone">{section.title}</h2>
                        <div className="section-content section-contentone" dangerouslySetInnerHTML={{ __html: section.content }}></div>
                        <div className="section-actions">
                          {section.actions.map((action, actionIndex) =>
                            <button className={action.variant} key={`section-${sectionIndex}-${actionIndex}`} onClick={() => { changeActionVisibility(tabIndex, sectionIndex, actionIndex) }}>
                              <i className={`fa fa-${action.icon} mr-1`}></i>
                              {console.log(action.title, "action.title")}
                              {action.title}
                            </button>
                          )}
                          {(page === tab.sections.length - 2 || page === tab.sections.length - 1) &&
                            <button className="green nxt_strt_btn" onClick={() => { page !== tab.sections.length - 1 ? nextPage() : nextTab() }}>
                              {page === tab.sections.length - 2 ? "Next" : "Next"}
                            </button>
                          }
                        </div>
                      </div>
                      <div className="flex2 pl-1">
                        {section.image !== "" && <img src={section.image} alt={section.title} className="img-responsive img_bdr" />}
                        {section.actions.map((action, actionIndex) =>
                          <div className={`section-desc ${action.active ? 'active' : ''}`} key={`section-desc-${actionIndex}`}>
                            <h3>{action.title}</h3>
                            <div className="sect_desc_cnt" dangerouslySetInnerHTML={{ __html: action.desc }}></div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>

              : tab.type === 'quiz' ?
                <div className={`tab-quiz ${tabIndex === currentTab ? 'active' : ''}`} key={`tab-quiz-${tabIndex}`}>
                  <div className="tab-header">
                    <div className="spacer"></div>
                    {data.tabs[currentTab].tabs.steps[currentStep].pdfControl &&
                      <Button text={data.tabs[currentTab].tabs.steps[currentStep]?.pdfFile} onClick={() => { onDownload(data.tabs[currentTab].tabs.steps[currentStep]?.pdfFilePath, data.tabs[currentTab].tabs.steps[currentStep]?.pdfFilePath) }} />
                    }
                  </div>
                  {score !== null && score !== undefined ?
                    <div className="score-board">
                      <h2>FINAL SCORE:</h2>
                      <div className="progress-bar">
                        <div className="progress" style={{ width: `${score}%` }}>{score}%</div>
                      </div>
                      <div className="progressbar_btn">
                        <button className="red" onClick={() => {
                          setScore();
                          setCurrentStep(0);
                          retryQuiz();
                        }}>
                          <i className="fa fa-undo mr-1"></i>
                          Retry
                        </button>
                        <button className="green" onClick={nextTab}>Next</button>
                      </div>
                    </div>
                    :
                    <>
                      <div className="tabs">
                        <div className="tab-bar">
                          <span className="title_font">{tab.tabs.steps[currentStep].title}</span>
                          {/* {tab.tabs.steps.map( (step, stepIndex) => (
                    
                    <div className={`global_button_two tab-item ${stepIndex===currentSubTab ? 'active' : ''}`} key={`tab-item-${stepIndex}`} onClick={ () => { changeSubTab(stepIndex); } }>
                    { tab.locked &&
                        <i className="mr-1 fa fa-lock"></i>
                     }
                     <span className="title_font">{ step.title }</span>
                  </div>
  
                  
                  )) } */}
                          {tab.tabs.steps.map((step, stepIndex) => {
                            if (currentStep == stepIndex) {
                              { console.log(step, "STEP123123") }
                              // if(currentStep===stepIndex) {

                              if (step.type === 'single-selection') {
                                if (step.orientation === 'horizontal') {
                                  return <SingleSelectHorizontal
                                    data={step}
                                    onComplete={nextStep}
                                    nextTab={nextTab}
                                  />;
                                } else {
                                  return <SingleSelectVertical
                                    data={step}
                                    onComplete={nextStep}
                                  />
                                }
                              } else if (step.type === 'multiple-selection') {
                                return <MultiSelectVertical
                                  data={step}
                                  onComplete={nextStep}
                                />
                              }
                            }
                            // }
                          })}
                        </div>
                      </div>
                    </>
                  }
                </div>
                : tab.type === 'keytakeaway' ?
                  <div className={`tab-keytakeaway ${tabIndex === currentTab ? 'active' : ''}`} key={`tab-keytakeaway-${tabIndex}`}>
                    {tab.sections.map((section, sectionIndex) => {
                      return (
                        <div className={`section ${page === sectionIndex ? 'active' : ''}`} key={`section-${sectionIndex}`}>
                          <div className="flex2 bg_bdr">
                            <h2 className="mb-2 section-title">{section.title}</h2>
                            <div className="section-content" dangerouslySetInnerHTML={{ __html: section.content }}></div>
                            <Button text="Continue" onClick={() => onComplete()} />
                          </div>
                          <div className="flex2 pl-1">
                            {section.image !== "" && <img src={section.image} alt={section.title} className="img-responsive img_bdr" />}
                          </div>
                        </div>
                      );

                    })}
                  </div>
                  :
                  ""}
          </Fragment>
        </>
      ))}
    </div>
  );

};

function download(url, fileName) {
  axios({
    url: url,
    method: 'GET',
    responseType: 'blob'
  })
    .then((response) => {
      const url = window.URL
        .createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch(e => {
      console.error(e.message);
      alert('Unable to download file');
    })
}

export default Tabs;